import React from 'react';
import { Select, TextField, TextDescription } from '@ann/web-components';

const BasicInfoSection = ({
    name,
    description,
    agentType,
    category,
    availableAgentTypes,
    availableCategories,
    onNameChange,
    onDescriptionChange,
    onTypeChange,
    onCategoryChange
}) => {
    const selectedAgentType = availableAgentTypes.find(t => t.value === agentType);
    return (
        <>
            <TextField
                label="Agent Name"
                placeholder="Enter agent name"
                value={name}
                onChange={onNameChange}
                size="small"
            />

            <TextDescription
                height="148px"
                label="Description (optional)"
                value={description}
                onChange={onDescriptionChange}
                placeholder="Briefly describe this agent purpose or function"
                size="small"
            />

            {/* <TextDescription
                height="800px"
                label="Description (optional)"
                value={description}
                onChange={onDescriptionChange}
                placeholder="Briefly describe this agent purpose or function"
                size="small"
            /> */}

            {/* <Select
                label="Agent Type"
                value={selectedAgentType}
                onChange={(value) => onTypeChange(value)}
                placeholder="Select agent type"
                size="small"
                width="100%"
            >
                <Select.Menu>
                    {availableAgentTypes.map((type) => (
                        <Select.Item
                            key={type.value}
                            label={type.label}
                            value={type.value}
                        >
                            {type.label}
                        </Select.Item>
                    ))}
                </Select.Menu>
            </Select>

            <Select
                label="Category"
                value={category}
                onChange={onCategoryChange}
                onSelectionChange={(value) => onCategoryChange(value)}
                placeholder="Select category"
                size="small"
                width="100%"
            >
                <Select.Menu>
                    {availableCategories.map((cat) => (
                        <Select.Item
                            key={cat.value}
                            label={cat.label}
                            value={cat.value}
                        >
                            {cat.label}
                        </Select.Item>
                    ))}
                </Select.Menu>
            </Select> */}
        </>
    );
};

export default BasicInfoSection;
